export interface CreateCommentResponse {
  id: number;
  createdAt: string;
  success: boolean;
}
